import clsx from "clsx";
import React from "react";
import { Icon } from "../Icon/Icon";
import { ImageMagnifier } from "../ImageMagnifier/ImageMagnifier";
import styles from "./ShipDeckPlan.module.scss";
import { ShipDirectionIcon } from "./ShipDirectionIcon/ShipDirectionIcon";

type Props = {
  className?: string;
  deckPlanSVGUrl: string;
  labels: {
    stern: string;
    bow: string;
    thirdGuestCapacity?: string;
    connectingSuite?: string;
    wheelchairAccessible?: string;
    bathShowerCombination?: string;
    bathShowerSeparate?: string;
  };
};

export const ShipDeckPlan: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  deckPlanSVGUrl,
  labels
}) => {
  return (
    <div className={clsx(styles.container, className)}>
      <ImageMagnifier src={deckPlanSVGUrl} />
      <ShipDirectionIcon
        variant="horizontal"
        sternLabel={labels.stern}
        bowLabel={labels.bow}
      />
      <ul className={styles.legend}>
        {labels.thirdGuestCapacity && (
          <li>
            <Icon
              padding={false}
              className={styles.icon}
              size="1.5x"
              name="3rd-guest-capacity"
            />
            {labels.thirdGuestCapacity}
          </li>
        )}
        {labels.connectingSuite && (
          <li>
            <Icon
              padding={false}
              className={styles.icon}
              size="1.5x"
              name="connecting-suite"
            />
            {labels.connectingSuite}
          </li>
        )}
        {labels.wheelchairAccessible && (
          <li>
            <Icon
              padding={false}
              className={styles.icon}
              size="1.5x"
              name="wheelchair"
            />
            {labels.wheelchairAccessible}
          </li>
        )}
        {labels.bathShowerCombination && (
          <li>
            <Icon
              padding={false}
              className={styles.icon}
              size="1.5x"
              name="bath-shower-combination"
            />
            {labels.bathShowerCombination}
          </li>
        )}
        {labels.bathShowerSeparate && (
          <li>
            <Icon
              padding={false}
              className={styles.icon}
              size="1.5x"
              name="bath-shower-separate"
            />
            {labels.bathShowerSeparate}
          </li>
        )}
      </ul>
    </div>
  );
};
